<template>
	<div id="main" class="column is-9">
		<section class="statistics">
			<div class="columns">
				<div class="column">
					<router-link to="/Newpsychic" class="button is-link add-psychic is-small"><i class="fa fa-plus"></i>&nbsp;Psychic</router-link>
					<h1>Statistics</h1>
				</div>
			</div>
			<div class="columns">
				<div class="column an-page-info">
					<p>
						This page is updated daily at 7am, 10am, 1pm, 4pm, 7pm and 10pm
					</p>
					<p>
						New calls/minutes = customer is new to that psychic for all calls during first 24 hours.
					</p>
				</div>
			</div>
			<div class="columns">
				<div class="column">
					<div class="columns refine">
						<div class="column">
							<div class="columns refine">
								<DatePicker 
									:startDate="startDate" 
									:key="`${startDate}${endDate}`"
									:endDate="endDate"
									@startDateInput="updateStartDate"
									@endDateInput="updateEndDate"
									@enter="updateData" />
								<div class="column is-7">
									<div class="columns refine is-mobile">
										<div class="column">
											<div class="field">
												<div class="control">
													<a class="button is-primary is-small" @click="updateData">
													Update </a>
												</div>
											</div>
										</div>
									<div class="column">
										<PageSize v-model="pageSize" @input="$refs.paginator.goToPage(0)" />
									</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
				<div class="column">
					<div class="columns refine">
						<div class="column">
							<a class="button is-primary is-small" @click="prevPeriod()">Prev Period</a>
						</div>
						<div class="column">
							<a class="button is-primary is-small" @click="currPeriod()">Current Period</a>
						</div>
						<div class="column">
							<a class="button is-primary is-small" @click="nextPeriod()">Next Period</a>
						</div>
					</div>
				</div>
			<Spinner size="large" v-if="!idle"></Spinner>
			<div class="card-table" v-if="idle">
				<div class="content">
					<div class="table-container">
						<table id="allPsychics" class="table is-narrow is-fullwidth is-striped">
							<thead>
								<tr>
									<th>
										<a @click="sortStat('user_name')">Agent</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('phone_extension')">Ext</a>
									</th>
									<th>
										<a @click="sortStat('tot_calls')">Tot Cls</a>
									</th>
									<th>
										<a @click="sortStat('rev_per_call')">RPC</a>
									</th>
									<th>
										<a @click="sortStat('tot_mins')">Tot Min</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('alc')">ALC</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('total_revenue')">Tot Rev</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('per_min_calls')">Per Min Cl</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('per_min_call_mins')">Per Min Cl Mins</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('per_min_call_pct')">Per Min Cl %</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('per_min_chats')">Per Min Chs</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('per_min_chat_mins')">Per Min Ch Mins</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('per_min_chat_pct')">Per Min Ch %</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('new_calls')">New Cls</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('new_call_mins')">New Cl Mins</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('new_call_avg')">New Cl Avg</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('new_chats')">New Chs</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('new_chat_mins')">New Ch Mins</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('new_chat_avg')">New Ch Avg</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('rep_pct')">Rep %</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('rep_calls')">Rep Cls</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('rep_call_mins')">Rep Cl Mins</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('rep_call_avg')">Rep Cl Avg</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('rep_chats')">Rep Chs</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('rep_chat_mins')">Rep Ch Mins</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('rep_chat_avg')">Rep Ch Avg</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('free_psychic_mins')">Free Mins</a>
									</th>
									<th class="is-hidden-mobile">
										<a @click="sortStat('total_missed')">Missed</a>
									</th>
									<th class="is-hidden-desktop">
										&nbsp;
									</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="psychic in this.paginatedData" :key="psychic.user_id">
									<td><router-link :to="`/psychics/` + psychic.user_id">{{ psychic.user_name }}</router-link></td>
									<td class="is-hidden-mobile">{{ psychic.phone_extension }}</td>
									<td>{{ psychic.tot_calls }}</td>
									<td>{{ psychic.rev_per_call }}</td>
									<td>{{ psychic.tot_mins }}</td>
									<td class="is-hidden-mobile">{{ psychic.alc }}</td>
									<td class="is-hidden-mobile">{{ psychic.total_revenue }}</td>
									<td class="is-hidden-mobile">{{ psychic.per_min_calls }}</td>
									<td class="is-hidden-mobile">{{ psychic.per_min_call_mins }}</td>
									<td class="is-hidden-mobile">{{ psychic.per_min_call_pct }}</td>
									<td class="is-hidden-mobile">{{ psychic.per_min_chats }}</td>
									<td class="is-hidden-mobile">{{ psychic.per_min_chat_mins }}</td>
									<td class="is-hidden-mobile">{{ psychic.per_min_chat_pct }}</td>
									<td class="is-hidden-mobile">{{ psychic.new_calls }}</td>
									<td class="is-hidden-mobile">{{ psychic.new_call_mins }}</td>
									<td class="is-hidden-mobile">{{ psychic.new_call_avg }}</td>
									<td class="is-hidden-mobile">{{ psychic.new_chats }}</td>
									<td class="is-hidden-mobile">{{ psychic.new_chat_mins }}</td>
									<td class="is-hidden-mobile">{{ psychic.new_chat_avg }}</td>
									<td class="is-hidden-mobile">{{ psychic.rep_pct }}</td>
									<td class="is-hidden-mobile">{{ psychic.rep_calls }}</td>
									<td class="is-hidden-mobile">{{ psychic.rep_call_mins }}</td>
									<td class="is-hidden-mobile">{{ psychic.rep_call_avg }}</td>
									<td class="is-hidden-mobile">{{ psychic.rep_chats }}</td>
									<td class="is-hidden-mobile">{{ psychic.rep_chat_mins }}</td>
									<td class="is-hidden-mobile">{{ psychic.rep_chat_avg }}</td>
									<td class="is-hidden-mobile">{{ psychic.free_psychic_mins }}</td>
									<td class="is-hidden-mobile">{{ psychic.total_missed }}</td>
									<td class="is-hidden-desktop">
										<button class="button is-info is-small" @click="selectedPsychic = psychic"><i class="fa fa-eye"></i></button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<Paginator ref="paginator" :itemCount="this.statistics.length" :pageSize="this.pageSize" v-model="pageNumber" />
			<Modal v-if="selectedPsychic" @close="selectedPsychic = null">
				<p class="modal-card-title" slot="title">
					{{ selectedPsychic.user_name }}
				</p>
				<ul slot="body">
					<li><span class="an-list-title">Extension:</span><span class="an-list-item">{{ selectedPsychic.phone_extension }}</span></li>
					<li><span class="an-list-title">Total Calls:</span><span class="an-list-item">{{ selectedPsychic.tot_calls }}</span></li>
					<li><span class="an-list-title">RPC Calls:</span><span class="an-list-item">{{ selectedPsychic.rev_per_call }}</span></li>
					<li><span class="an-list-title">Total Mins:</span><span class="an-list-item">{{ selectedPsychic.tot_mins }}</span></li>
					<li><span class="an-list-title">ALC:</span><span class="an-list-item">{{ selectedPsychic.alc }}</span></li>
					<li><span class="an-list-title">Total Revenue:</span><span class="an-list-item">{{ selectedPsychic.total_revenue }}</span></li>
					<li><span class="an-list-title">Per Min Calls:</span><span class="an-list-item">{{ selectedPsychic.per_min_calls }}</span></li>
					<li><span class="an-list-title">Per Min Call Mins:</span><span class="an-list-item">{{ selectedPsychic.per_min_call_mins }}</span></li>
					<li><span class="an-list-title">Per Min Call Pct:</span><span class="an-list-item">{{ selectedPsychic.per_min_call_pct }}</span></li>
					<li><span class="an-list-title">Per Min Chats:</span><span class="an-list-item">{{ selectedPsychic.per_min_chats }}</span></li>
					<li><span class="an-list-title">Per Min Chat Mins:</span><span class="an-list-item">{{ selectedPsychic.per_min_chat_mins }}</span></li>
					<li><span class="an-list-title">Per Min Chat Pct:</span><span class="an-list-item">{{ selectedPsychic.per_min_chat_pct }}</span></li>
					<li><span class="an-list-title">New Calls:</span><span class="an-list-item">{{ selectedPsychic.new_calls }}</span></li>
					<li><span class="an-list-title">New Call Mins:</span><span class="an-list-item">{{ selectedPsychic.new_call_mins }}</span></li>
					<li><span class="an-list-title">New Call Avg:</span><span class="an-list-item">{{ selectedPsychic.new_call_avg }}</span></li>
					<li><span class="an-list-title">New Chat Mins:</span><span class="an-list-item">{{ selectedPsychic.new_chat_mins }}</span></li>
					<li><span class="an-list-title">New Chat Avg:</span><span class="an-list-item">{{ selectedPsychic.new_chat_avg }}</span></li>
					<li><span class="an-list-title">Rep Calls:</span><span class="an-list-item">{{ selectedPsychic.rep_calls }}</span></li>
					<li><span class="an-list-title">Rep Call Mins:</span><span class="an-list-item">{{ selectedPsychic.rep_call_mins }}</span></li>
					<li><span class="an-list-title">Rep Call Pct:</span><span class="an-list-item">{{ selectedPsychic.rep_pct }}</span></li>
					<li><span class="an-list-title">Rep Chats:</span><span class="an-list-item">{{ selectedPsychic.rep_chats }}</span></li>
					<li><span class="an-list-title">Rep Chat Mins:</span><span class="an-list-item">{{ selectedPsychic.rep_chat_mins }}</span></li>
					<li><span class="an-list-title">Rep Chat Avg:</span><span class="an-list-item">{{ selectedPsychic.rep_chat_avg }}</span></li>
					<li><span class="an-list-title">Free Mins:</span><span class="an-list-item">{{ selectedPsychic.free_psychic_mins }}</span></li>
					<li><span class="an-list-title">Missed:</span><span class="an-list-item">{{ selectedPsychic.total_missed }}</span></li>
				</ul>
			</Modal>
		</section>
	</div>
</template>

<script>
	import moment from "moment-timezone"
	import Spinner from 'vue-simple-spinner'
	import Paginator from "../Paginator"
	import PageSize from "../PageSize"
	import DatePicker from "../DatePicker"
	import Modal from "../Modal.vue"

	export default {
		components: {
			Paginator,
			PageSize,
			DatePicker,
			Modal,
			Spinner,
		},
		data() {
			return {
				selectedPsychic: null,
				pageNumber: 0,
				pageSize: 10,
				statistics: [],
				sortCol: "total_revenue",
				sortDir: -1,
				startDate: moment(Date.now()).add(-7, 'days').valueOf().toString(),
				endDate: Date.now().toString(),
				idle: false,
			}
		},
		computed: {
			paginatedData() {
				const start = this.pageNumber * this.pageSize,
					end = start + this.pageSize

				return this.sortedStatistics.slice(start, end)
			},
			sortedStatistics() {
				let sorted = this.statistics
				return sorted.sort((a, b) => {
					if (a[this.sortCol] < b[this.sortCol]) return -1 * this.sortDir
					if (a[this.sortCol] > b[this.sortCol]) return 1 * this.sortDir
					return 0
				})
			}
		},
		methods: {
			async currPeriod() {
				this.startDate = this.$root.$data.state.payStart.valueOf().toString()
				this.endDate = this.$root.$data.state.payEnd.valueOf().toString()
				await this.updateData()
			},
			async nextPeriod() {
				const cur = new Date(parseInt(this.startDate))
				if (cur >= new Date()) { return }
				const start = moment(cur).add(7, "days")
				const end = moment(start).add(6, "days")
				this.startDate = start.valueOf().toString()
				this.endDate = end.valueOf().toString()
				await this.updateData()
			},
			async prevPeriod() {
				const cur = new Date(parseInt(this.startDate))
				const start = moment(cur).add(-7, "days")
				const end = moment(start).add(6, "days")
				this.startDate = start.valueOf().toString()
				this.endDate = end.valueOf().toString()
				await this.updateData()
			},
			updateStartDate(date) {
				this.startDate = moment(date).valueOf().toString()
			},
			updateEndDate(date) {
				this.endDate = moment(date).valueOf().toString()
			},
			sortStat(col) {
				if (this.sortCol === col) {
					this.sortDir = this.sortDir === -1 ? 1 : -1
				} else {
					this.sortCol = col
					this.sortDir = -1
				}
			},
			async updateData() {
				this.idle = false
				this.statistics = await this.$root.$data.getters.getAllStatistics(this.$root.$data.state, this.startDate, this.endDate, true)
				this.idle = true
			},
		},
		async created() {
			this.startDate = this.$root.$data.state.allStatistics.startDate
			this.endDate = this.$root.$data.state.allStatistics.endDate
			this.startDate = this.startDate || this.$root.$data.state.payStart.valueOf().toString()
			this.endDate = this.endDate || this.$root.$data.state.payEnd.valueOf().toString()
			this.statistics = await this.$root.$data.getters.getAllStatistics(this.$root.$data.state, this.startDate, this.endDate)
			this.idle = true
		}
	}
</script>